import React from "react";
import { Button } from 'react-bootstrap';
import { useLocation,useNavigate } from 'react-router-dom';
import { RichTextBoxHelper } from "../../Utils/richtextbox.helper";

export default function Actividad({ actividad }) {
    const navigate = useNavigate();
    const dateTimeOptions = {
        weekday: "long",
        year: "numeric",
        month: "numeric",
        day: "2-digit",
    };
    const timeOptions = {
        hour: "numeric",
        minute: "numeric",
    };

    const handleRedirectClick = () => {
        switch (actividad.Tipo) {
            case "Evento":
                navigate(`/ActividadEventoEdit?Id=${actividad.IdSec}`);
                break;
            case "Llamada":
                navigate(`/ActividadLlamadaEdit?Id=${actividad.IdSec}`);
                break;
            case "Tarea":
                navigate(`/ActividadTareaEdit?Id=${actividad.IdSec}`);
                break;
            default:
                break;
        }
    };

    function setIcon(type) {
        switch (type) {
            case "Evento":
                return <i className="badge badge-dot badge-dot-xl badge-warning"> </i>;
            case "Llamada":
                return <i className="badge badge-dot badge-dot-xl badge-primary"> </i>;
            case "Tarea":
                return <i className="badge badge-dot badge-dot-xl badge-success"> </i>;
            default:
                return <i className="badge badge-dot badge-dot-xl badge-danger"> </i>;
        }
    }

    function getTareaDescription(desc) {
        return RichTextBoxHelper.getText(desc);
    }

    return (
        <div className="vertical-timeline-item vertical-timeline-element ">
            <div>
        <span className="vertical-timeline-element-icon ">
          {setIcon(actividad.Tipo)}
        </span>
                <div className="vertical-timeline-element-content ">
                    <div className="content-text">
                        <Button
                            variant="link"
                            className="bootstrapiso link-button"
                            onClick={handleRedirectClick}
                        >
                            <h5 className="m-0 p-0">{actividad._TipoSolicitudDesc}</h5>
                        </Button>
                        <p>
                            Solicitud #{actividad.IdSec}
                        </p>
                    </div>
                    <span className="vertical-timeline-element-date">
            {new Date(actividad.FechaActividad).toLocaleDateString(
                "es-GB",
                dateTimeOptions
            )}
                        ,
            <br />
                        {new Date(actividad.FechaActividad).toLocaleTimeString(
                            "es-DO",
                            timeOptions
                        )}
          </span>
                </div>
            </div>
        </div>
    );
}
